import React from "react";
import { useSearchParams } from "react-router-dom";

import ClearableTextField from "./ClearableTextField";

import { useDebounce, useGetUrlParams } from "hooks";

const ParamsKeywordSearch = ({
  paramKey = "search",
  debounceDelay = 750,
  minLength = 4,
  stripHyphen = false,
  ...props
}) => {
  const URL_PARAMS = useGetUrlParams();

  const [keyword, setKeyword] = React.useState("");

  const [searchParams, setSearchParams] = useSearchParams();

  const search = searchParams.get(paramKey) || "";

  const { debouncedValue, isBusy } = useDebounce(keyword, debounceDelay);

  // methods
  const handleClearFilter = () => {
    delete URL_PARAMS[paramKey];
    delete URL_PARAMS.perPage;
    setSearchParams({ ...URL_PARAMS, page: 1 });
    setKeyword("");
  };

  const handleSearchParam = (value) => {
    delete URL_PARAMS.perPage;
    const cleanValue = stripHyphen ? value.replace(/-/g, "").trim() : value;
    setSearchParams({ ...URL_PARAMS, page: 1, [paramKey]: cleanValue });
  };

  React.useEffect(() => {
    setKeyword(search);
  }, [search]);

  React.useEffect(() => {
    if (!debouncedValue) {
      if (search) handleClearFilter();
      return;
    }
    if (debouncedValue.length < minLength) return;
    handleSearchParam(debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  return (
    <ClearableTextField
      typing={isBusy}
      value={keyword}
      onChange={(e) => {
        const val = stripHyphen ? e.target.value.replace(/-/g, "") : e.target.value;
        setKeyword(val);
      }}
      handleClear={handleClearFilter}
      {...props}
    />
  );
};

export default ParamsKeywordSearch;
